var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_c('draggable',{model:{value:(_vm.draggableItems),callback:function ($$v) {_vm.draggableItems=$$v},expression:"draggableItems"}},[_vm._l((_vm.orderedItems),function(item){return [_c('style-dialog-content-class',_vm._b({key:item.value,on:{"setActive":_vm.setActiveItem}},'style-dialog-content-class',{
          item,
          isActive: item.value === _vm.activeItem.value,
          layerType: _vm.layerType,
        },false))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }